import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

const Nav = styled.header`
  width: 100%;
  max-width: 960px;
  margin: 0 auto 1rem;
  padding: 0 0.25rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  z-index: 2;
`;

const Brand = styled(Link)`
  font-size: 1.35rem;
  font-weight: 800;
  color: var(--text-primary);
  letter-spacing: -0.02em;

  span {
    color: var(--primary-color);
  }
`;

const NavLinks = styled.nav`
  display: flex;
  align-items: center;
  gap: 1.25rem;
`;

const NavLink = styled(Link)`
  color: var(--text-secondary);
  font-size: 0.95rem;
  font-weight: 600;
  transition: color 0.2s ease;

  &:hover {
    color: var(--text-primary);
  }
`;

const CtaLink = styled(Link)`
  font-size: 0.9rem;
  font-weight: 700;
  color: #0C0F14;
  background: var(--primary-color);
  padding: 0.5rem 1rem;
  border-radius: 999px;

  &:hover {
    background: var(--primary-light);
  }
`;

const SiteHeader = ({ showCta = true }) => (
  <Nav>
    <Brand to="/" aria-label="FounderDNA home">
      Founder<span>DNA</span>
    </Brand>
    <NavLinks>
      <NavLink to="/types">Founder types</NavLink>
      {showCta && <CtaLink to="/">Take the test</CtaLink>}
    </NavLinks>
  </Nav>
);

export default SiteHeader;
